// Image delivery helper.
//
// Heavy marketing images (multi-MB JPG/PNG from external CDNs) intermittently
// fail to load on the FIRST mobile paint — too many large requests fire at once
// and some connections get reset, leaving broken-image icons until a refresh.
//
// The backend already exposes an on-the-fly resize + WebP + 24h-cache proxy at
// /api/v2/public/image-proxy. Routing the big marketing images through it cuts
// the payload by ~80% and serves a cached, device-sized WebP — so first paint
// is fast and reliable. Local/public assets (/images/...) are left untouched.

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

// Only these origins are accepted by the backend proxy allow-list.
const PROXY_ORIGINS = [
  'customer-assets.emergentagent.com',
  'emergentagent.com',
  'vercel-storage.com',
  'blob.vercel-storage.com',
];

/**
 * Return a proxied, resized WebP URL for a heavy external image.
 * @param {string} url   original image URL
 * @param {number} w     target max width in px (DPR-aware: pass ~2x display width)
 * @param {number} q     WebP quality (30–95)
 */
export function proxyImg(url, w = 800, q = 78) {
  if (!url || typeof url !== 'string') return url;
  // Same-origin / public assets and data URIs need no proxying.
  if (url.startsWith('/') || url.startsWith('data:')) return url;
  try {
    const host = new URL(url).host;
    if (!PROXY_ORIGINS.some((o) => host.includes(o))) return url;
    return `${BACKEND}/api/v2/public/image-proxy?url=${encodeURIComponent(url)}&w=${w}&q=${q}`;
  } catch {
    return url;
  }
}
